import PropTypes from 'prop-types';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import { reactiveStore } from '@ts-private/reactive-store';
import { useEffect } from 'react';

export const setApolloFetchingInternalValues = reactiveStore(() => {});

const ApolloFetchingComponent = ({ store, options }) => {
  const { setInternalValues } = useApolloFetching(store, options);

  useEffect(() => {
    setApolloFetchingInternalValues.set(setInternalValues);
    return () => {
      setApolloFetchingInternalValues.set(() => {});
    };
  }, [setInternalValues]);

  return null;
};

ApolloFetchingComponent.propTypes = {
  store: PropTypes.object,
  options: PropTypes.object
};

export default ApolloFetchingComponent;
